export enum Route {
  MAIN_SCREEN = "main",
  DMS_SCREEN = "dms",
  ELLADA_FIT_SCREEN = "ellada-fit",
  GREEKDAR_SCREEN = "gd",
  NOT_FOUND = "not_found",
}

export enum SubRoute {
  DMS_SCREEN_ACTIVATE = "activate",
  ELLADA_FIT_SCREEN_ACTIVATE = "activate",
  GREEKDAR_SCREEN_ACTIVATE = "activate",
}
